<template>
  <div class="card-article has-small-icon" :class="{ 'half': cardData?.width === '50' }" :data-type="cardData.type">
    <h3 class="card-title"><a :href="cardData.url">{{ cardData.title }}</a></h3>
    <a :href="cardData.url" class="btn-round-icon-only btn-arrow">
      <span class="sr-only">Lire l'article</span>
    </a>
  </div>
</template>

<script>
export default {
  props: {
    cardData: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
